/*
 * Shared picking logic for the three layout options.
 * Each option's markup provides the hooks it uses; anything missing is skipped. Hooks:
 *   [data-fw-wallets] [data-fw-bags]      swatch/card containers (rendered here; option sets data-fw-style="swatch|card")
 *   [data-fw-wname] [data-fw-bname]       chosen names
 *   [data-fw-wshot] [data-fw-bshot]       chosen images (innerHTML = shot markup)
 *   [data-fw-set-title]                   "Regina wallet + Regina Mini Satchel"
 *   [data-fw-bnote]                       match / low-stock note
 *   [data-fw-cta] [data-fw-sticky-btn] [data-fw-sticky-sub] [data-fw-err] [data-fw-live]
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-fw]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  // Weekly deadline: "this Sunday" in US Eastern time, so every shopper sees the same date. On Sunday itself it
  // reads "today". Markup keeps a date-less fallback ("this Sunday") in case Intl is missing.
  (function () {
    var els = $$('[data-fw-ends]');
    if (!els.length || !window.Intl) return;
    var now = {};
    try {
      new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric'})
        .formatToParts(new Date()).forEach(function (p) { now[p.type] = p.value; });
    } catch (e) { return; }
    var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(now.weekday);
    if (dow < 0) return;
    var ahead = (7 - dow) % 7;
    var sunday = new Date(Date.UTC(Number(now.year), Number(now.month) - 1, Number(now.day) + ahead));
    var date = sunday.toLocaleDateString('en-US', {timeZone: 'UTC', month: 'short', day: 'numeric'});
    var today = ahead === 0;
    var text = {
      hero: today ? 'Offer ends today, Sunday, ' + date : 'Offer ends this Sunday, ' + date,
      note: today ? 'Offer ends tonight (Sunday, ' + date + '), or sooner if the free bags run out.'
                  : 'Offer ends Sunday, ' + date + ', or sooner if the free bags run out.'
    };
    els.forEach(function (el) { var t = text[el.getAttribute('data-fw-ends')]; if (t) el.textContent = t; });
  })();

  var data;
  try { data = JSON.parse($('[data-fw-pool]').textContent || '{}'); } catch (e) { data = {}; }
  var wallets = (data.wallets || []).filter(function (p) { return p && p.id && p.img; });
  var bags = (data.bags || []).filter(function (p) { return p && p.id && p.img; });
  if (!wallets.length || !bags.length) {
    // Offer is over (every free bag is gone): say so instead of leaving a dead buy box.
    var pick = root.querySelector('.a__pick');
    if (pick) pick.innerHTML = '<div class="fw__over"><p class="fw__over-t">Every free Mini Satchel has found a home.</p>' +
      '<p>Thank you for being part of it. Our wallets are still here at their normal price.</p>' +
      '<a class="fw__atc" href="/collections/all">See all Feratia designs</a></div>';
    var stk = root.querySelector('[data-fw-sticky]'); if (stk) stk.remove();
    return;
  }

  var LOW = 25;
  var OFFER_KEY = root.getAttribute('data-offer-key') || 'wallet-satchel';
  // Static HTML prototypes have no Shopify object; the theme section always does.
  var IS_PROTOTYPE = !window.Shopify || root.hasAttribute('data-fw-prototype');
  var money = function (n) { return '$' + n.toFixed(2); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  };
  var sized = function (url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var shot = function (p, cls, w, lazy) {
    return '<span class="fw__shot ' + cls + '"><img src="' + esc(sized(p.img, w)) + '" alt="" width="600" height="800"' +
      (lazy ? ' loading="lazy"' : '') + ' decoding="async"></span>';
  };
  var label = function (p) { return p.n + (p.kind === 'bag' ? ' Mini Satchel' : ' wallet'); };
  var matchOf = function (w) { return bags.filter(function (b) { return b.design === w.design; })[0]; };

  // Option J: deepest stock first, so the designs most likely to ship lead; the page opens on 9 wallets.
  var STYLE0 = root.getAttribute('data-fw-style') || 'swatch';
  if (STYLE0 === 'vcard') wallets = wallets.slice().sort(function (a, b) { return (b.stock || 0) - (a.stock || 0); });
  // Two full rows of the grid: 4 columns from 760px (8 designs), 3 columns on phones (9 designs).
  var wideMq = window.matchMedia('(min-width:760px)');
  var firstCount = function () { return STYLE0 === 'vcard' ? (wideMq.matches ? 8 : 9) : Infinity; };
  var WALLETS_FIRST = firstCount();
  var showAllWallets = false;

  var st = {wallet: wallets[0], bag: matchOf(wallets[0]) || bags[0], bagChosen: false, busy: false};

  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }
  function setHtml(sel, html) { $$(sel).forEach(function (el) { el.innerHTML = html; }); }

  // Detail mode per page (data-fw-detail-mode): '' = none on thumbs, 'lens' = small details button on each
  // thumb, 'tap' = tapping a thumb opens details (choose inside), 'peek' = inline quick-view strip under the row.
  var MODE = root.getAttribute('data-fw-detail-mode') || '';
  var STYLE = root.getAttribute('data-fw-style') || 'swatch';
  function swatch(p, attr, cls, w, lazy, on, extra) {
    var isBag = p.kind === 'bag';
    var tick = on ? '<span class="fw__sw-tick' + (isBag ? ' fw__sw-tick--gold' : '') + '" aria-hidden="true">✓</span>' : '';
    var lens = MODE === 'lens'
      ? '<span class="fw__lens" role="button" tabindex="0" data-lens aria-label="Details: ' + esc(label(p)) + '">⤢</span>' : '';
    var wrapTag = MODE === 'lens' ? 'div' : 'button';
    var open = MODE === 'lens'
      ? '<div class="fw__swatch fw__swatch--lens' + (isBag ? ' fw__swatch--bag' : '') + '" ' + attr + ' data-on="' + on + '">' +
        '<button type="button" class="fw__sw-pick" data-pick-only aria-pressed="' + on + '" aria-label="' + esc(label(p)) + '"></button>'
      : '<button type="button" class="fw__swatch' + (isBag ? ' fw__swatch--bag' : '') + '" ' + attr + ' aria-pressed="' + on +
        '" aria-label="' + esc(label(p)) + '" title="' + esc(p.n) + '">';
    return open + shot(p, cls, w, lazy) + extra + tick + lens +
      '<span class="fw__swatch-n">' + esc(p.n) + '</span></' + wrapTag + '>';
  }

  // G: wide card = product shot + model photo + name/price + choose; details live in the card itself.
  function wide(p, attr, on, lazy, extra) {
    var isBag = p.kind === 'bag';
    var photo = (p.imgs || [])[0];
    return '<button type="button" class="fw__wide' + (isBag ? ' fw__wide--bag' : '') + '" ' + attr + ' aria-pressed="' + on + '">' +
      '<span class="fw__wide-art">' + shot(p, isBag ? 'fw__shot--bag' : '', 400, lazy) + '</span>' +
      '<span class="fw__wide-ph">' + (photo ? '<img src="' + esc(sized(photo, 300)) + '" alt="" width="300" height="375"' + (lazy ? ' loading="lazy"' : '') + ' decoding="async">' : '') + '</span>' +
      '<span class="fw__wide-b">' + extra + '<span class="n">' + esc(label(p)) + '</span>' +
      '<span class="pr">' + (isBag ? '<s>$109.95</s> <b>Free</b>' : '$49.95') + '</span>' +
      (p.note ? '<span class="nt">' + esc(p.note) + '</span>' : '') +
      '<span class="ch' + (on ? ' is-on' : '') + '">' + (on ? 'Chosen ✓' : 'Choose') + '</span></span></button>';
  }

  // J: product card with its own "View details" button (opens that product's popup); the card body chooses.
  function vcard(p, attr, on, lazy, extra) {
    var isBag = p.kind === 'bag';
    return '<div class="fw__vcard' + (isBag ? ' fw__vcard--bag' : '') + '" ' + attr + ' data-on="' + on + '">' +
      '<button type="button" class="fw__vcard-pick" data-pick-only aria-pressed="' + on + '" aria-label="Choose ' + esc(label(p)) + '">' +
      shot(p, isBag ? 'fw__shot--bag' : '', window.innerWidth >= 760 ? 300 : 240, lazy) + extra +
      (on ? '<span class="fw__tick' + (isBag ? ' fw__tick--gold' : '') + '" aria-hidden="true">✓</span>' : '') +
      '<span class="fw__vcard-n">' + esc(p.n) + '</span>' +
      '<span class="fw__vcard-p">' + (isBag ? '<s>$109.95</s> <b>Free</b>' : '$49.95') + '</span></button>' +
      '<button type="button" class="fw__vcard-detl" data-lens aria-label="View details: ' + esc(label(p)) + '">View details ›</button></div>';
  }

  function renderPickers() {
    var wbox = $('[data-fw-wallets]'), bbox = $('[data-fw-bags]');
    var style = root.getAttribute('data-fw-style') || 'swatch';
    if (wbox) {
      var visible = showAllWallets ? wallets : wallets.slice(0, WALLETS_FIRST);
      wbox.innerHTML = visible.map(function (p, i) {
        var on = st.wallet === p;
        if (style === 'wide') return wide(p, 'data-w="' + i + '"', on, i > 3, '');
        if (style === 'vcard') return vcard(p, 'data-w="' + i + '"', on, i > 3, '');
        if (style === 'card') {
          return '<button type="button" class="fw__card" data-w="' + i + '" aria-pressed="' + on + '">' +
            shot(p, '', 400, i > 5) + '<span class="fw__card-n">' + esc(p.n) + '</span>' +
            '<span class="fw__card-p">$49.95</span>' + (on ? '<span class="fw__tick" aria-hidden="true">✓</span>' : '') + '</button>';
        }
        return swatch(p, 'data-w="' + i + '"', 'fw__shot--sq', 280, i > 5, on, '');
      }).join('');
    }
    var more = $('[data-fw-more]');
    if (more) {
      var hiddenCount = wallets.length - WALLETS_FIRST;
      more.hidden = showAllWallets || hiddenCount <= 0;
      if (!more.hidden) more.textContent = 'Show ' + hiddenCount + ' more designs';
    }
    if (bbox) {
      bbox.innerHTML = bags.map(function (p, i) {
        var on = st.bag === p, match = st.wallet.design === p.design;
        if (style === 'wide') return wide(p, 'data-b="' + i + '"', on, true, match ? '<span class="fw__match">Match</span>' : '');
        if (style === 'vcard') return vcard(p, 'data-b="' + i + '"', on, true, match ? '<span class="fw__match">Match</span>' : '');
        if (style === 'card') {
          return '<button type="button" class="fw__card fw__card--bag" data-b="' + i + '" aria-pressed="' + on + '">' +
            shot(p, 'fw__shot--bag', 400, true) + '<span class="fw__card-n">' + esc(p.n) + '</span>' +
            '<span class="fw__card-p"><s>$109.95</s> Free</span>' + (match ? '<span class="fw__match">Match</span>' : '') +
            (on ? '<span class="fw__tick fw__tick--gold" aria-hidden="true">✓</span>' : '') + '</button>';
        }
        return swatch(p, 'data-b="' + i + '"', 'fw__shot--bag', 180, true, on, match ? '<span class="fw__match">Match</span>' : '');
      }).join('');
    }
  }

  function render() {
    var active = document.activeElement, key = null;
    if (active && root.contains(active)) {
      if (active.hasAttribute('data-w')) key = '[data-w="' + active.getAttribute('data-w') + '"]';
      else if (active.hasAttribute('data-b')) key = '[data-b="' + active.getAttribute('data-b') + '"]';
    }
    renderPickers();
    var w = st.wallet, b = st.bag;
    setText('[data-fw-wname]', w.n);
    setText('[data-fw-bname]', b.n);
    setHtml('[data-fw-wshot]', shot(w, '', 700));
    setHtml('[data-fw-bshot]', shot(b, 'fw__shot--bag', 600));
    setText('[data-fw-set-title]', w.n + ' wallet + ' + b.n + ' Mini Satchel');
    var note = $('[data-fw-bnote]');
    if (note) {
      if (b.stock && b.stock <= LOW) note.innerHTML = '<span class="low">Only ' + b.stock + ' left in ' + esc(b.n) + '</span>';
      else if (w.design === b.design) note.textContent = 'Matches your wallet.';
      else note.textContent = matchOf(w) || st.bagChosen ? '' : 'The matching bag is gone, so we chose another for you.';
    }
    setText('[data-fw-sticky-sub]', w.n + ' wallet + free ' + b.n + ' bag');
    $$('[data-fw-cta]').forEach(function (cta) {
      if (st.busy) return;
      cta.disabled = false;
      if (!cta.hasAttribute('data-fw-keep')) cta.textContent = cta.getAttribute('data-add-label') || 'Add my set · $49.95';
    });
    // J: one-line summary of the set next to the second Add-to-cart
    setText('[data-fw-set-line]', w.n + ' wallet + free ' + b.n + ' Mini Satchel');
    // H: wizard — big preview of the piece being picked in the current step
    setHtml('[data-fw-big-w]', shot(w, '', 800));
    setHtml('[data-fw-big-b]', shot(b, 'fw__shot--bag', 700));
    if (key) { var el = root.querySelector(key); if (el) el.focus(); }
  }
  function announce(msg) { var l = $('[data-fw-live]'); if (l) l.textContent = msg; }
  var moreBtn = $('[data-fw-more]');
  if (moreBtn) moreBtn.addEventListener('click', function () {
    showAllWallets = true; render();
    var first = root.querySelector('[data-w="' + WALLETS_FIRST + '"] button'); if (first) first.focus();
  });

  root.addEventListener('click', function (e) {
    var w = e.target.closest('[data-w]'), b = e.target.closest('[data-b]');
    var item = w ? wallets[Number(w.getAttribute('data-w'))] : (b ? bags[Number(b.getAttribute('data-b'))] : null);
    if (item && (MODE === 'lens' || STYLE === 'vcard') && e.target.closest('[data-lens]')) { openSheet(item); return; }
    if (item && MODE === 'tap') { openSheet(item); return; }
    if (item && MODE === 'peek') {
      var sel = w ? '[data-w="' + w.getAttribute('data-w') + '"]' : '[data-b="' + b.getAttribute('data-b') + '"]';
      choose(item); openPeek(item, root.querySelector(sel)); return;
    }
    if (w) {
      st.wallet = wallets[Number(w.getAttribute('data-w'))];
      if (!st.bagChosen) st.bag = matchOf(st.wallet) || st.bag;
      render();
      announce(label(st.wallet) + ' chosen. Free bag: ' + label(st.bag) + '.');
    } else if (b) {
      st.bag = bags[Number(b.getAttribute('data-b'))];
      st.bagChosen = true;
      render();
      announce(label(st.bag) + ' chosen as your free bag.');
    }
  });

  function addToCart() {
    if (st.busy) return;
    st.busy = true;
    $$('[data-fw-cta]').forEach(function (cta) { cta.disabled = true; if (!cta.hasAttribute('data-fw-keep')) cta.textContent = 'Adding your set…'; });
    setError('');
    var props = {_feratia_offer: OFFER_KEY};
    try { var src = new URL(window.location.href).searchParams.get('utm_source'); if (src) props._feratia_src = src; } catch (e) {}
    // One tap = one set (1 wallet + 1 bag); the discount function makes the bag free for lines carrying the offer key.
    var items = [{id: Number(st.wallet.id), quantity: 1, properties: props},
                 {id: Number(st.bag.id), quantity: 1, properties: props}];
    if (IS_PROTOTYPE) {
      setTimeout(function () {
        window.alert('Prototype: this would add to cart\n\n' + JSON.stringify(items, null, 1));
        st.busy = false; render();
      }, 400);
      return;
    }
    post('/cart/add.js', {items: items}).then(function () {
      if (document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]')) {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles: true}));
        setTimeout(function () { st.busy = false; render(); }, 1200);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      st.busy = false; render();
      setError(err && err.status === 422 && err.message
        ? err.message + ' Please choose another design.'
        : 'Something went wrong. Please try again, or write to cs@feratia.com.');
      var e = $('[data-fw-err]'); if (e) e.scrollIntoView({block: 'center'});
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.ok) return j;
        throw {status: r.status, message: j.description || j.message || ''};
      });
    });
  }
  function setError(msg) { var e = $('[data-fw-err]'); if (e) e.textContent = msg; }
  $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.addEventListener('click', addToCart); });
  var onWide = function () { var n = firstCount(); if (n !== WALLETS_FIRST) { WALLETS_FIRST = n; render(); } };
  if (wideMq.addEventListener) wideMq.addEventListener('change', onWide); else if (wideMq.addListener) wideMq.addListener(onWide);

  var sticky = $('[data-fw-sticky]');
  var ctas = $$('[data-fw-cta]');
  if (sticky && 'IntersectionObserver' in window && ctas.length) {
    sticky.inert = true;
    var seen = new Map();
    var away = !!document.querySelector('[data-fw-sticky-away]');
    var stickyWas = false;
    // The store's popup app draws its teaser inside an open shadow root, bottom-centre over the bar.
    var liftPopupTeaser = function (on, h) {
      Array.prototype.forEach.call(document.body.children, function (el) {
        var sr = el.shadowRoot;
        if (!sr || !sr.querySelector('.hcp-layer, .hcp-teaser-wrap')) return;
        var tag = sr.querySelector('style[data-fw-lift]');
        if (!on) { if (tag) tag.remove(); return; }
        if (!tag) { tag = document.createElement('style'); tag.setAttribute('data-fw-lift', ''); sr.appendChild(tag); }
        tag.textContent = '.hcp-teaser-wrap{margin-bottom:' + (h + 8) + 'px}';
      });
    };
    var syncSticky = function () {
      var anyVisible = false, allAbove = true;
      ctas.forEach(function (c) { var v = seen.get(c); if (!v) return; if (v.visible) anyVisible = true; if (v.top >= 0) allAbove = false; });
      // Hidden while any Add-to-cart is on screen; shown once the shopper has scrolled past the first one.
      var firstTop = (seen.get(ctas[0]) || {}).top;
      // data-fw-sticky-away: the only Add to cart is low on the page, so show the bar once the shopper
      // has scrolled past the top and no Add to cart is on screen (above or below).
      var on = away ? (!anyVisible && window.scrollY > 500)
                    : (!anyVisible && typeof firstTop === 'number' && firstTop < 0);
      sticky.classList.toggle('is-on', on); sticky.inert = !on; sticky.setAttribute('aria-hidden', String(!on));
      if (on !== stickyWas) {
        stickyWas = on;
        document.documentElement.classList.toggle('fw-sticky-on', on);
        document.documentElement.style.setProperty('--fw-sticky-h', sticky.offsetHeight + 'px');
        liftPopupTeaser(on, sticky.offsetHeight);
      }
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, {visible: en.isIntersecting, top: en.boundingClientRect.top}); });
      syncSticky();
    });
    ctas.forEach(function (c) { io.observe(c); });
    if (away) window.addEventListener('scroll', syncSticky, {passive: true});
  }

  // simple swipe gallery (options that have one)
  var track = $('[data-fw-track]');
  if (track) {
    var dots = $('[data-fw-dots]');
    var slides = function () { return track.children.length; };
    var cur = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var go = function (i) { track.scrollTo({left: Math.max(0, Math.min(slides() - 1, i)) * track.clientWidth, behavior: 'smooth'}); };
    var photos = function () {
      var a = st.bag.imgs || [], b = st.wallet.imgs || [], out = [];
      for (var i = 0; out.length < 8 && (i < a.length || i < b.length); i += 1) {
        if (a[i]) out.push({src: a[i], alt: label(st.bag)});
        if (b[i] && out.length < 8) out.push({src: b[i], alt: label(st.wallet)});
      }
      return out;
    };
    var renderGallery = function () {
      var first = track.getAttribute('data-first') || '';
      var list = photos();
      track.innerHTML = (first ? '<div class="fw__slide">' + first + '</div>' : '') + list.map(function (p) {
        return '<div class="fw__slide"><img src="' + esc(sized(p.src, 700)) + '" alt="' + esc(p.alt) + '" width="700" height="875" loading="lazy" decoding="async"></div>';
      }).join('');
      if (first) { setHtml('[data-fw-wshot]', shot(st.wallet, '', 700)); setHtml('[data-fw-bshot]', shot(st.bag, 'fw__shot--bag', 600)); }
      if (dots) dots.innerHTML = Array.prototype.map.call(track.children, function (_, i) {
        return '<button type="button" data-i="' + i + '" aria-label="Photo ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>';
      }).join('');
      track.scrollLeft = 0;
    };
    var sync = function () { if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', String(k === cur())); }); };
    track.addEventListener('scroll', sync, {passive: true});
    if (dots) dots.addEventListener('click', function (e) { var d = e.target.closest('[data-i]'); if (d) go(Number(d.getAttribute('data-i'))); });
    $$('[data-fw-prev]').forEach(function (b) { b.addEventListener('click', function () { go(cur() - 1); }); });
    $$('[data-fw-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur() + 1); }); });
    var origRender = render;
    render = function () { origRender(); renderGallery(); };
  }

  function choose(p) {
    if (p.kind === 'bag') { st.bag = p; st.bagChosen = true; }
    else { st.wallet = p; if (!st.bagChosen) st.bag = matchOf(p) || st.bag; }
    render();
    announce(label(p) + ' chosen.' + (p.kind === 'bag' ? '' : ' Free bag: ' + label(st.bag) + '.'));
  }

  // Peek strip (mode 'peek'): an inline quick view that opens under the tapped thumb's row.
  function openPeek(p, cell) {
    var grid = cell.parentElement;
    var old = grid.querySelector('.fw__peek');
    if (old) old.remove();
    var photo = (p.imgs || [])[0];
    var strip = document.createElement('div');
    strip.className = 'fw__peek';
    strip.innerHTML =
      '<div class="fw__peek-img">' + (photo
        ? '<img src="' + esc(sized(photo, 400)) + '" alt="' + esc(label(p)) + '" width="400" height="500" decoding="async">'
        : shot(p, p.kind === 'bag' ? 'fw__shot--bag' : '', 400)) + '</div>' +
      '<div class="fw__peek-b"><b>' + esc(label(p)) + '</b>' +
      '<span class="pr">' + (p.kind === 'bag' ? '<s>$109.95</s> Free with your wallet' : '$49.95') + '</span>' +
      (p.note ? '<p>' + esc(p.note) + '</p>' : '') +
      '<span class="row"><span class="on">Chosen ✓</span>' +
      '<button type="button" class="fw__peek-more" data-peek-more>More photos ›</button></span></div>' +
      '<button type="button" class="fw__peek-x" data-peek-x aria-label="Close">×</button>';
    // place after the last cell of the tapped row
    var cells = Array.prototype.filter.call(grid.children, function (c) { return !c.classList.contains('fw__peek'); });
    var cols = Math.max(1, Math.round(grid.clientWidth / cell.offsetWidth));
    var idx = cells.indexOf(cell), rowEnd = cells[Math.min(cells.length - 1, idx - (idx % cols) + cols - 1)];
    rowEnd.insertAdjacentElement('afterend', strip);
    strip.querySelector('[data-peek-x]').addEventListener('click', function () { strip.remove(); });
    strip.querySelector('[data-peek-more]').addEventListener('click', function () { openSheet(p); });
    strip.scrollIntoView({block: 'nearest', behavior: 'smooth'});
  }

  // H: step navigation (markup provides [data-fw-step="1|2|3"] panels and [data-fw-go="n"] buttons)
  var steps = $$('[data-fw-step]');
  if (steps.length) {
    var showStep = function (n) {
      steps.forEach(function (p) { p.hidden = p.getAttribute('data-fw-step') !== String(n); });
      $$('[data-fw-dot]').forEach(function (d) {
        var k = Number(d.getAttribute('data-fw-dot'));
        d.setAttribute('aria-current', String(k === n)); d.classList.toggle('is-done', k < n);
      });
      var top = $('[data-fw-steps]'); if (top) top.scrollIntoView({behavior: 'smooth', block: 'start'});
    };
    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-fw-go]'); if (g) showStep(Number(g.getAttribute('data-fw-go')));
    });
    showStep(1);
  }
  // I: tapping the big compare images opens the full photo sheet
  root.addEventListener('click', function (e) {
    var big = e.target.closest('[data-fw-open]');
    if (big) openSheet(big.getAttribute('data-fw-open') === 'bag' ? st.bag : st.wallet);
  });

  // ---------------------------------------------------------------- detail sheet
  var FACTS = {
    wallet: '4.3″ × 7.9″ × 1″ · Phone, cards, cash. Zip-around, wrist strap included. Premium vegan leather.',
    bag: '5.4″ × 7.8″ × 4.2″ · Two top handles + detachable shoulder strap. Zip closure. Premium vegan leather.'
  };
  var sheet = document.createElement('dialog');
  sheet.className = 'fw__sheet';
  sheet.setAttribute('aria-label', 'Details');
  root.appendChild(sheet);
  function openSheet(p) {
    var isBag = p.kind === 'bag';
    var on = isBag ? st.bag === p : st.wallet === p;
    var photos = (p.imgs || []).slice(0, 7);
    var n = photos.length + 1;
    var slides = [shot(p, isBag ? 'fw__shot--bag' : '', 900)].concat(photos.map(function (u) {
      return '<img src="' + esc(sized(u, 800)) + '" alt="' + esc(label(p)) + '" width="800" height="1000" loading="lazy" decoding="async">';
    }));
    sheet.innerHTML =
      '<div class="fw__sheet-hd"><span class="fw__sheet-kind">' + (isBag ? 'Free Mini Satchel' : 'Wallet') + '</span>' +
      '<button type="button" class="fw__sheet-x" data-x aria-label="Close">×</button></div>' +
      '<div class="fw__sheet-galwrap">' +
        '<div class="fw__sheet-gal" data-g>' + slides.map(function (h) { return '<div class="fw__sheet-sl">' + h + '</div>'; }).join('') + '</div>' +
        '<span class="fw__sheet-n" data-n aria-live="polite">1 / ' + n + '</span>' +
        (n > 1 ? '<span class="fw__sheet-swipe" data-swipe aria-hidden="true">Swipe for more photos ›</span>' : '') +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--p" data-ap aria-label="Previous photo">‹</button>' +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--n" data-an aria-label="Next photo">›</button>' +
      '</div>' +
      '<div class="fw__sheet-dots" data-d>' + slides.map(function (_, i) { return '<button type="button" data-i="' + i + '"' + (i ? '' : ' aria-current="true"') + ' aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') + '</div>' +
      '<div class="fw__sheet-b">' +
        '<div class="fw__sheet-row"><h3>' + esc(label(p)) + '</h3><span class="pr">' + (isBag ? '<s>$109.95</s> <b>Free</b>' : '$49.95') + '</span></div>' +
        (p.note ? '<p class="note">' + esc(p.note) + '</p>' : '') +
        '<p class="facts">' + (isBag ? '5.4″ × 7.8″ × 4.2″ · handles + shoulder strap · zip' : '4.3″ × 7.9″ × 1″ · zip-around · wrist strap') + ' · vegan leather</p>' +
        '<button type="button" class="fw__sheet-pick' + (on ? ' is-on' : '') + '" data-pick>' + (on ? 'Chosen ✓' : (isBag ? 'Choose this bag' : 'Choose this wallet')) + '</button>' +
      '</div>';
    var g = sheet.querySelector('[data-g]'), d = sheet.querySelector('[data-d]'), cnt = sheet.querySelector('[data-n]'), sw = sheet.querySelector('[data-swipe]');
    var cur = function () { return Math.round(g.scrollLeft / Math.max(1, g.clientWidth)); };
    var go = function (i) { g.scrollTo({left: Math.max(0, Math.min(n - 1, i)) * g.clientWidth, behavior: 'smooth'}); };
    g.addEventListener('scroll', function () {
      var i = cur();
      Array.prototype.forEach.call(d.children, function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      cnt.textContent = (i + 1) + ' / ' + n;
      if (sw && i > 0) sw.hidden = true; // the hint has done its job
    }, {passive: true});
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) go(Number(b.getAttribute('data-i'))); });
    sheet.querySelector('[data-ap]').addEventListener('click', function () { go(cur() - 1); });
    sheet.querySelector('[data-an]').addEventListener('click', function () { go(cur() + 1); });
    sheet.querySelector('[data-x]').addEventListener('click', closeSheet);
    sheet.querySelector('[data-pick]').addEventListener('click', function () { choose(p); closeSheet(); });
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    document.documentElement.classList.add('fw-sheet-open');
  }
  function closeSheet() { if (sheet.close) sheet.close(); else sheet.removeAttribute('open'); }
  sheet.addEventListener('close', function () { document.documentElement.classList.remove('fw-sheet-open'); });
  sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fw-detail]');
    if (b) openSheet(b.getAttribute('data-fw-detail') === 'bag' ? st.bag : st.wallet);
  });

  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-lens]')) { e.preventDefault(); e.target.click(); }
  });

  render();
})();

/*
 * Judge.me widget on the set page: 5-star reviews first (with photos first inside each star level), then 4, 3, 2, 1;
 * one "Load more reviews" button; no sort menu, no filtering by star. Every review stays reachable.
 * Store-wide Judge.me settings stay as they are. Pages come from Judge.me's own public widget endpoint, one star level
 * at a time (sort_by=pictures_first&filter_rating=N), and are set up by Judge.me (jdgm.customizeReviews) so photos,
 * read-more and votes work as on its own pages. If anything fails, Judge.me's widget is left as it was.
 */
(function () {
  'use strict';
  var box = document.querySelector('.fw .fw__jm');
  if (!box) return;
  var PER_PAGE = 5;
  var LEVELS = [5, 4, 3, 2, 1];
  var LABEL = 'Load more reviews';
  // Judge.me's CDN now and then answers without CORS headers; the origin API (the pager's own data-url) is the retry
  var ENDPOINTS = ['https://cdn.judge.me/reviews/reviews_for_widget', 'https://api.judge.me/reviews/reviews_for_widget'];

  var widget, list, btn;
  var at = {level: 0, page: 0, total: null}; // last page loaded of LEVELS[level]
  var busy = false;

  function url(level, page, endpoint) {
    var p = {url: '', shop_domain: '', platform: 'shopify'};
    try { var sp = window.jdgm && jdgm.shopParams && jdgm.shopParams(); if (sp) for (var k in sp) p[k] = sp[k]; } catch (e) {}
    p.product_id = widget.getAttribute('data-id');
    p.page = page; p.per_page = PER_PAGE; p.sort_by = 'pictures_first'; p.filter_rating = LEVELS[level];
    if (!p.shop_domain && window.Shopify) p.shop_domain = p.url = Shopify.shop;
    return endpoint + '?' + Object.keys(p).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]); }).join('&');
  }

  function getJson(level, page, i) {
    return fetch(url(level, page, ENDPOINTS[i])).then(function (r) { if (!r.ok) throw new Error('judge.me ' + r.status); return r.json(); })
      .catch(function (e) {
        if (i + 1 >= ENDPOINTS.length) throw e;
        return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return getJson(level, page, i + 1); });
      });
  }

  function fetchPage(level, page) {
    return getJson(level, page, 0)
      .then(function (j) {
        var t = document.createElement('template');
        t.innerHTML = j.html || '';
        return {total: Number(j.total_count) || 0, revs: Array.prototype.slice.call(t.content.querySelectorAll('.jdgm-rev'))};
      });
  }

  // Next page in order; moves on to the next star level when one runs out. Resolves to [] when everything is shown.
  function next() {
    var lv = at.level, pg = at.page + 1;
    if (at.total != null && at.page * PER_PAGE >= at.total) { lv += 1; pg = 1; }
    if (lv >= LEVELS.length) return Promise.resolve([]);
    return fetchPage(lv, pg).then(function (res) {
      if (pg === 1) at.total = res.total;
      at.level = lv; at.page = pg;
      if (!res.revs.length) { at.total = 0; return next(); }
      return res.revs;
    });
  }

  function more() {
    return at.level < LEVELS.length - 1 || at.total == null || at.page * PER_PAGE < at.total;
  }

  function add(revs, replace) {
    if (replace) list.innerHTML = '';
    revs.forEach(function (r) { list.appendChild(r); });
    // let Judge.me set up the new reviews: read more, votes, dates (every review not yet set up), then the photo viewer
    // (without setupPictures a photo opens in a new tab instead of Judge.me's gallery)
    try {
      if (window.jdgm && jdgm.customizeReviews) jdgm.customizeReviews();
      if (window.jdgm && jdgm.setupPictures && jdgm.$) jdgm.setupPictures(jdgm.$(revs));
    } catch (e) { if (window.console) console.warn('[handbag-set] reviews setup', e); }
    btn.hidden = !more();
  }

  function load(replace) {
    if (busy) return Promise.resolve();
    busy = true;
    btn.disabled = true; btn.textContent = 'Loading…';
    return next().then(function (revs) { add(revs, replace); })
      .catch(function (e) { if (window.console) console.warn('[handbag-set] reviews', e); if (replace) throw e; })
      .then(function () { busy = false; btn.disabled = false; btn.textContent = LABEL; });
  }

  function start() {
    widget = box.querySelector('.jdgm-widget');
    list = widget && widget.querySelector('.jdgm-rev-widg__reviews');
    // wait until Judge.me has set up its widget, so our first page replaces its list and not the other way round
    if (!list || !box.querySelector('.jdgm--done-setup')) return false;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hs-rv__more';
    btn.textContent = LABEL;
    btn.addEventListener('click', function () { load(false); });
    list.parentNode.insertBefore(btn, list.nextSibling);
    load(true).then(function () { box.classList.add('hs-rv-on'); }, function () { btn.remove(); });
    return true;
  }
  if (!start()) {
    var tries = 0;
    var t = setInterval(function () { if (start() || ++tries > 60) clearInterval(t); }, 250);
  }
})();
